























import { listFactory } from '@/main/pages';

import { store } from './store/list';
import { NAME } from './constants';
import { apiProvider } from './api';

export default listFactory(NAME, store).extend({
	methods: {
		async uzaverka() {
			this.startLoading();
			const { data } = await apiProvider.ndObjednavkaUzaverka(this.filter);
			if (data[0].ErrCode !== 0) {
				await this.showErrorNotification(data[0].ErrMsg);
			}
			if (data.length > 1 && data[1].ErrCode !== 1) {
				await this.showErrorNotification(data[1].ErrMsg);
			}
			this.refreshFun();
			this.endLoading();
		},
		korekce() {
			// TODO: bude v jine user storce
			console.log('TODO');
		},
	},
});
